import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { downloadHelper } from 'src/app/helper/class/downloadHelper';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { ResponseData } from 'src/app/helper/interface/response';

@Injectable({
  providedIn: 'root'
})
export class MasterApiService {
  payrollTbl = ['salary_category', 'payroll_head', 'leave_policy', 'leave_type', 'hra_percentage', 'work_from_type', 'holiday_type', 'experience_slot', 'payroll_type', 'payroll_group', 'payroll_report_status', 'bible_words']
  constructor(public http: HttpClient, private downloadHelper: downloadHelper) { }
  getById(tbl: string, id: string | number): Promise<ResponseData> {
    return lastValueFrom(this.http.get(`getById/${tbl}/${id}`))
  }
  searchAgent(terms: any) {
    return lastValueFrom(this.http.get(`search/staff/${terms}`))
  }
  searchSchool(terms: any) {
    return lastValueFrom(this.http.get(`school/search/${terms}`))
  }
  getFullData(tbl: string, cond: any = '', isFull = false, lazy = {}) {
    const tbl_ext = `/` + JSON.stringify(cond);
    const lasyP = isEmptyObj(lazy) ? '' : '/' + JSON.stringify(lazy);
    if (isFull) {
      return lastValueFrom(this.http.get(`getfull/${tbl}${tbl_ext}${lasyP}`,))
    } else {
      return lastValueFrom(this.http.get(`get/${tbl}${tbl_ext}${lasyP}`));
    }
  }
  saveData(tbl: string, data: any) {
    return lastValueFrom(this.http.post(`/saveData/${tbl}`, data))
  }
  saveField(data: any) {
    return lastValueFrom(this.http.post(`/field/save`, data))
  }
  getField(lazy: any = {}) {
    const lasyP = isEmptyObj(lazy) ? '' : '/' + JSON.stringify(lazy);
    return lastValueFrom(this.http.get(`/field/getList${lasyP}`,))
  }

  getMobileApp(lazy: any = {}) {
    const lasyP = isEmptyObj(lazy) ? '' : '/' + JSON.stringify(lazy);
    return lastValueFrom(this.http.get(`/app/getList${lasyP}`,))
  }

  getFieldByid(id: string | number, isFull = true) {
    const d = isFull ? 'true' : 'false';
    return lastValueFrom(this.http.get(`/field/get/${id}`,))
  }

  getChurchByField(id: any) {
    return lastValueFrom(this.http.get(`/church/getByField/${id}`))
  }

  generateEmail(id: string | number, data: any) {
    return lastValueFrom(this.http.post(`/genEmail/${id}`, data))
  }

  getFieldByZone(id: any) {
    let data: any;
    if (Array.isArray(id)) {
      data = JSON.stringify(id);
    }
    return lastValueFrom(this.http.get(`/field/getByZone/${data}`))
  }

  exportData(tName = '', data: any = []) {
    data = JSON.stringify(data);
    return lastValueFrom(this.http.post(`/exportData/${tName}`, data, { responseType: 'blob' }))
  }

  exportReportData(tName = '', data: any = []) {
    data = JSON.stringify(data);
    return lastValueFrom(this.http.post(`/report/getReport/${tName}`, data, { responseType: 'blob' }))
  }

  search(tbl: string, terms: any) {
    return lastValueFrom(this.http.get(`/search/${tbl}/${terms}`))
  }
  getDocContent(id: any) {
    return lastValueFrom(this.http.get(`/genContent/INVOICE/${id}`));
  }
  getDownContent(id: any) {
    return lastValueFrom(this.http.get(`/print/INVOICE/${id}`));
  }

  pdfDownload(id: any, file_name: string) {
    const url = `/print/INVOICE/${id}`,
      fileName = `${file_name}.pdf`
    return this.downloadHelper.downloadApi(url, 'GET', fileName)
  }
  addNotice(data: any) {
    return lastValueFrom(this.http.post(`notice/save`, data))
  }
  noticeGetList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`notice/getList/${lasyP}`))
  }
  noticeGetListData(schoolFkId?: string | number) {
    return lastValueFrom(this.http.get(`notice/getList/${schoolFkId ? `${schoolFkId}` : 'null'}`));
  }
  filterNoticeGetListData(id: any, data: any) {
    return lastValueFrom(this.http.get(`notice/filterData/${id}/${data}`));
  }
  noticeDelete(id: any) {
    return lastValueFrom(this.http.delete(`/notice/delete/${id}`))
  }
  noticeGetById(id: any) {
    return lastValueFrom(this.http.get(`notice/getById/${id}`))
  }
  holidayList() {
    return lastValueFrom(this.http.get(`holiday/getAllHolidaysBySchool/1`))

  }
  uploadBulkData(data: { file_name: string, type: 'STAFF' | 'STUDENT' }) {
    return lastValueFrom(this.http.post(`excelImport`, data))
  }
  downloadSampleData() {
    return (`https://dcc.gemsbihar.info/api/uploads/dcc_student.xlsx`)
  }

  filterCourseBySchool(schoolId: string | number) {
    return lastValueFrom(this.http.get(`school/findCourses/${schoolId}`));
  }

  filterSchoolByFeeGroup(feeGroupId: string | number) {
    return lastValueFrom(this.http.get(`school/getSchoolByFeesGroup/${feeGroupId}`));
  }

  filterStudentBySchool(schoolId?) {
    let school_id = schoolId
    if (Array.isArray(school_id)) {
      school_id = school_id.join(',')
    }
    const whereField = [{ value: school_id, matchMode: "equals", colName: "school_fk_id" }]
    const lasyP = JSON.stringify(whereField);
    return lastValueFrom(this.http.get(`student/search/null/${lasyP}`));
  }
}
